(function ($) {
  $('#ctaModal').on('show.bs.modal', function (event) {
    const button = $(event.relatedTarget);
    const formId = button.data('form');

    if (!window.MktoForms2) {
      let s = document.createElement('script');
      s.src = "https://go.premise.com/js/forms2/js/forms2.min.js";

      s.onload = function () {
        MktoForms2.loadForm("//go.premise.com", "870-CRW-973", formId, function () {
          $('#ctaModal #spinner').remove();
        });
      };

      document.body.appendChild(s);
    } else {
      MktoForms2.loadForm("//go.premise.com", "870-CRW-973", formId, function () {
        $('#ctaModal #spinner').remove();
      });
    }
  });
})(jQuery);
